module.exports = __webpack_public_path__ + "static/media/bg.f5d1df72.png";